import { ConfigRecord } from "./ConfigRecord";
import { DesiredStateItem } from "./DesiredState";
import * as GlobalTypes from "../../types";

export type ButtonMappingsRecord = ConfigRecord<ButtonMappingsConfig>;
export type ButtonMappingsConfig = ButtonMapping[];

export class ButtonMapping {
    UUID:GlobalTypes.UUIDV4;
    ButtonUUID:GlobalTypes.UUIDV4;
    TargetUUID:GlobalTypes.UUIDV4;
    MappingType:ButtonMappingTypes = ButtonMappingTypes.TOGGLE_STATUS;
    DesiredState:DesiredStateItem = null;
} 
export enum ButtonMappingTypes {
    DECREASE = "DECREASE",
    INCREASE = "INCREASE",
    SET = "SET",
    SET_NO_TOGGLE = "SET_NO_TOGGLE",
    TOGGLE_STATUS = "TOGGLE_STATUS",
}
